export enum ELanguages {
  en = "en",
  ru = "ru",
}
